/*=========================================================================================
  File Name: moduleBillConfig.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleBillConfigState.js'
import mutations from './moduleBillConfigMutations.js'
import actions from './moduleBillConfigActions.js'
import getters from './moduleBillConfigGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

